import React from 'react';
import { Link } from 'gatsby-plugin-react-i18next';


const ContactUsLink = ({ children }) => {
	return ( <Link to="/contact-us">
	           {children}
			 </Link>
			);
};

export default ContactUsLink;